import { Component, OnDestroy } from '@angular/core';
import { ResourceService } from 'sce-core';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchService } from '../../search/search.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { DataTableConfig } from '../../search/models/data-table-config';
import { Condition, SearchCriteria, Clause } from '../../search/models/search-filter-model';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT, REFRESH_SEARCH_EVENT } from '../../search/search-constants';
import { HttpClient } from '@angular/common/http';
import { COMMON_FIELDS, META_DATA, SEARCH_OPERATORS } from '../../../constants';

@Component({
  selector: 'lfwms-multi-column-popup',
  templateUrl: './multi-column-popup.component.html',
  styleUrls: ['./multi-column-popup.component.css']
})
export class MultiColumnPopupComponent implements OnDestroy {

  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  public isLoading: boolean = true;
  public searchService: SearchService;
  public resourceService: ResourceService;  
  public currentRow: any;
  public property: any;
  public alertService: any;
  public tableEditor: any;
  public propertyArray: any[] = ['orderLineNo', 'lot', 'loc', 'id'];
  public tableIds: Array<string> = ['orderlinenotd', 'lotdetailtd', 'locdetailtd', 'iddetailtd'];
  public primaryIdProperties: Array<string> = ['orderLineNumber', 'lot', 'locId', 'id'];
  public searchServices: SearchService[] = [];
  public selectedFacility: any;
  // current search service selected
  public selectedStep: number;
  // label for the popup is the stepname
  public selectedStepName: string = '';
  public stepNameMap = {
    'orderLineNo': 'lbl_multi_order',
    'lot': 'lbl_multi_lot',
    'loc': 'lbl_multi_loc',
    'id': 'job_move_id',
    'channel': 'lbl_channel'
  };
  // auto population event where selected value is passed to parent
  public eventSubject = new Subject<any>();
  // label for buttons in popup
  public buttonConfirm: string = '';
  public buttonNext: string = '';
  // obj items to be passed to parent
  public itemsToPopulate: any = {};
  // storer facility and sku for selected line item
  public storerKey: string;
  public facility: string;
  public sku: string;
  public lottable01: string;
  public lottable02: string;
  public lottable03: string;
  public lottable04: string;
  public lottable05: string;
  public lottable06: string;
  public lottable07: string;
  public lottable08: string;
  public lottable09: string;
  public lottable10: string;
  public lottable11: string;
  public lottable12: string;
  public lottable13: string;
  public lottable14: string;
  public lottable15: string;
  // flag to re-initialize table on search service change
  public showTable: boolean = false;
  public selectedPropertyValue = {};
  // flag to identify wether it is newly created or by back or forward navigation
  public isNewInstanceCreated: boolean = false;
  public facilityList: string[] = [];

  constructor(coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    protected http$: HttpClient ) {
    this.resourceService = coreServiceRegistry.resourceService;
    this.buttonConfirm = this.resourceService.get('btn_confirm');
    this.buttonNext = this.resourceService.get('lbl_next');
    this.eventSubject = new Subject<any>();
  }

  public getStorerConfig() { 
    const storerKey = this.currentRow.cells['storerKey'].cVal;
     const response$ = this.http$.get(`api/core/${storerKey}/multifacilityshipmentright`)
       .subscribe((response: any) => {
          if(response && response.facilityList && response.facilityList.length > 0) {
            this.facilityList = response['facilityList'];
          }
        },
        (error: any) => {
          if (error.error.length !== 0) {
            if (error.error.statusCode !== 200) {
              return Observable.throw(error.error.statusMessage);
            }
          }
        });
  }

  /**
   * initializeComponents when lens icon is clicked in parent component
   */
  public initializeComponents(dataEditor: any) {
    this.tableEditor = dataEditor;
    this.getStorerConfig();
    // creating four search service.
    // LOGIC :- [single table intance and switching search service on selection].
    this.tableIds.forEach((tableId: string, index: any) => {
      this.searchServices.push(this.createSearchServices(tableId, this.primaryIdProperties[index]));
    });
    // setting current search service properties.
    this.selectedStep = this.propertyArray.indexOf(this.property);
    this.selectedStepName = this.resourceService.get(this.stepNameMap[this.property]);
    this.searchService = this.searchServices[this.selectedStep];
    this.searchParams = this.searchService.searchParams;
    this.searchStatus = this.searchService.searchStatus;
    this.selectedPropertyValue[this.property] = this.currentRow.cells[this.property].cVal ? this.currentRow.cells[this.property].cVal : '';
    this.isNewInstanceCreated = this.currentRow.cells[this.property].cVal ? true : false;
    //[LFWM-3573] to store facility so, we can get data
    this.selectedFacility = this.currentRow.cells['facility'].cVal;
    // getting table for the currently selected search service
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.searchService.setSearchCriteria(this.createDefaultSearchCriteria(this.currentRow, this.property, this.isNewInstanceCreated));
        this.searchService.fetchSearchResults()
          .subscribe((data: any) => {
            this.searchStatus.hasResults = true;
            this.searchStatus.recordCount = this.searchService.pagedData.pageDefinition.recordCount;
            const event = new SearchEvent(NEW_SEARCH_EVENT);
            event.isSearchSuccess = true;
            this.searchService.publishEvent(event);
            if (this.isNewInstanceCreated) {
              if (this.searchService.getPagedData().pageRows.length === 1) {
                this.searchService.getPagedData().pageRows[0].isSelected = true;
              }
              this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
            }
          });
        this.isLoading = false;
        this.showTable = true;
      });
  }

  /**
   * create an instance of SearchServices
   */
  public createSearchServices(tableId: any, primaryId: any) {
    const lookupParams = this.createLookupParamsForColumn(tableId, primaryId);
    lookupParams.alertService = this.alertService;
    lookupParams.tableEditor = this.tableEditor;
    const lookupStatus = new SearchStatus();
    return this.sharedServiceRegistry.createSearchService(lookupParams, lookupStatus);

  }

  public ngOnDestroy() {
    // Memory Cleanup
    this.searchService = null;
    this.searchServices = [];
  }

  // create search criteria on newly created or forward or backward navigation
  protected createDefaultSearchCriteria(currentRow: any, property: any, isNewInstance?: boolean, isClearSearchInstance?: boolean) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createSearchCondition(1);
    defaultCondition1.isReadOnly = true;
    defaultCondition1.isMandatory = true;
    defaultCondition1.operator = 'AND';
    if (property === 'orderLineNo') {
      defaultCondition1.clauses = this.createClauseForOrderLineNo(currentRow, property, isNewInstance, isClearSearchInstance);
    } else if (property === 'lot') {
      defaultCondition1.clauses = this.createClauseForLot(currentRow, property, isNewInstance, isClearSearchInstance);
    } else if (property === 'loc') {
      defaultCondition1.clauses = this.createClauseForLoc(currentRow, property, isNewInstance, isClearSearchInstance);
    } else if (property === 'id') {
      defaultCondition1.clauses = this.createClauseForId(currentRow, property, isNewInstance, isClearSearchInstance);
    }
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }


  /**
   * construct criteria for OrderLineNo
   */
  public createClauseForOrderLineNo(currentRow: any, property: any, isNewInstance?: boolean, isClearSearchInstance?: boolean) {
    let orderLineclauseArray: any[] = [];
    const defaultClause1 = new Clause();
    defaultClause1.column = 'orderKey';
    defaultClause1.value = currentRow.cells[defaultClause1.column].cVal;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = '';
    if (isNewInstance) {
      const defaultClause2 = new Clause();
      defaultClause2.column = 'orderLineNumber';
      defaultClause2.value = currentRow.cells[defaultClause2.column] ? currentRow.cells[defaultClause2.column].cVal : currentRow.cells['orderLineNo'].cVal;
      defaultClause2.operation = '=';
      defaultClause2.logicalOperation = 'AND';
      if (defaultClause2.value) {
        orderLineclauseArray = [defaultClause1, defaultClause2];
      } else {
        orderLineclauseArray = [defaultClause1];
      }
    } else {
      orderLineclauseArray = [defaultClause1];
    }
    return orderLineclauseArray;
  }

  /**
   * construct criteria for Loc
   */
  public createClauseForLot(currentRow: any, property: any, isNewInstance?: boolean, isClearSearchInstance?: boolean) {
    const LotClauseArray: any[] = [];
    const facilityColumnValue = this.getPrimaryColumnValue('facility', isNewInstance, currentRow);
    if (facilityColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'facility';
      defaultClause1.operation = '=';
      defaultClause1.value = facilityColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const storerColumnValue = this.getPrimaryColumnValue('storerKey', isNewInstance, currentRow);
    if (storerColumnValue) {
      const defaultClause2 = new Clause();
      defaultClause2.column = 'storerKey';
      defaultClause2.operation = '=';
      defaultClause2.value = storerColumnValue;
      defaultClause2.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause2);
    }
    const skuValue = this.getPrimaryColumnValue('sku', isNewInstance, currentRow);
    if (skuValue) {
      const defaultClause3 = new Clause();
      defaultClause3.column = 'sku';
      defaultClause3.operation = '=';
      defaultClause3.value = skuValue;
      defaultClause3.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause3);
    }
    const lottable01ColumnValue = this.getPrimaryColumnValue('lottable01', isNewInstance, currentRow);
    if (lottable01ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable01';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable01ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable02ColumnValue = this.getPrimaryColumnValue('lottable02', isNewInstance, currentRow);
    if (lottable02ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable02';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable02ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable03ColumnValue = this.getPrimaryColumnValue('lottable03', isNewInstance, currentRow);
    if (lottable03ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable03';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable03ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable04ColumnValue = this.getPrimaryColumnValue('lottable04', isNewInstance, currentRow);
    if (lottable04ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable04';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable04ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable05ColumnValue = this.getPrimaryColumnValue('lottable05', isNewInstance, currentRow);
    if (lottable05ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable05';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable05ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable06ColumnValue = this.getPrimaryColumnValue('lottable06', isNewInstance, currentRow);
    if (lottable06ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable06';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable06ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable07ColumnValue = this.getPrimaryColumnValue('lottable07', isNewInstance, currentRow);
    if (lottable07ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable07';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable07ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable08ColumnValue = this.getPrimaryColumnValue('lottable08', isNewInstance, currentRow);
    if (lottable08ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable08';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable08ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable09ColumnValue = this.getPrimaryColumnValue('lottable09', isNewInstance, currentRow);
    if (lottable09ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable09';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable09ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable10ColumnValue = this.getPrimaryColumnValue('lottable10', isNewInstance, currentRow);
    if (lottable10ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable10';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable10ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable11ColumnValue = this.getPrimaryColumnValue('lottable11', isNewInstance, currentRow);
    if (lottable11ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable11';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable11ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable12ColumnValue = this.getPrimaryColumnValue('lottable12', isNewInstance, currentRow);
    if (lottable12ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable12';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable12ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable13ColumnValue = this.getPrimaryColumnValue('lottable13', isNewInstance, currentRow);
    if (lottable13ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable13';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable13ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable14ColumnValue = this.getPrimaryColumnValue('lottable14', isNewInstance, currentRow);
    if (lottable14ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable14';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable14ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    const lottable15ColumnValue = this.getPrimaryColumnValue('lottable15', isNewInstance, currentRow);
    if (lottable15ColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lottable15';
      defaultClause1.operation = '=';
      defaultClause1.value = lottable15ColumnValue;
      defaultClause1.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
      LotClauseArray.push(defaultClause1);
    }
    if (!isClearSearchInstance) {
      const lotValue = this.getPrimaryColumnValue('lot', isNewInstance, currentRow);
      if (lotValue) {
        const defaultClause4 = new Clause();
        defaultClause4.column = 'lot';
        defaultClause4.value = lotValue;
        defaultClause4.operation = '=';
        defaultClause4.logicalOperation = LotClauseArray.length > 0 ? 'AND' : '';
        LotClauseArray.push(defaultClause4);
      }

    }

    return LotClauseArray;
  }

  /**
   * method to retrive value of corresponding property
   */
  public getPrimaryColumnValue(colName: string, isNewInstance: boolean, currentRow: any) {
    let ColumnValue: string = '';
    if (colName === 'sku') {
      colName = colName === 'sku' && currentRow.cells[colName] ? colName : 'commodity';
    }
    if (isNewInstance) {
      if(colName !== 'lottable01' && colName !== 'lottable02' && colName !== 'lottable03' && 
          colName !== 'lottable04' && colName !== 'lottable05' && colName !== 'lottable06' && 
          colName !== 'lottable07' && colName !== 'lottable08' && colName !== 'lottable09' && 
          colName !== 'lottable10' && colName !== 'lottable11' && colName !== 'lottable12' && 
          colName !== 'lottable13' && colName !== 'lottable14' && colName !== 'lottable15')
        if (currentRow.cells[colName].cVal) {
          ColumnValue = currentRow.cells[colName].cVal;
      }
    } else {
      if (colName === 'facility') {
        ColumnValue = this.facility !== undefined && this.facility !== null ? this.facility : currentRow.cells['facility'].cVal;
      } else if (colName === 'storerKey') {
        ColumnValue = this.storerKey !== undefined && this.storerKey !== null ? this.storerKey : currentRow.cells['storerKey'].cVal;
      } else if (colName === 'sku') {
        if (this.sku !== undefined && this.sku !== null) {
          ColumnValue = this.sku;
        } else {
          ColumnValue = currentRow.cells['commodity'] ? currentRow.cells['commodity'].cVal : currentRow.cells[colName].cVal;
        }
      } else if (colName === 'lottable01') {
        if (this.lottable01 !== undefined && this.lottable01 !== null) {
          ColumnValue = this.lottable01;
        } else if (this.tableEditor.lottable01 !== undefined && this.tableEditor.lottable01 !== null) {
          ColumnValue = this.tableEditor.lottable01;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable02') {
        if (this.lottable02 !== undefined && this.lottable02 !== null) {
          ColumnValue = this.lottable02;
        } else if (this.tableEditor.lottable02 !== undefined && this.tableEditor.lottable02 !== null) {
          ColumnValue = this.tableEditor.lottable02;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable03') {
        if (this.lottable03 !== undefined && this.lottable03 !== null) {
          ColumnValue = this.lottable03;
        } else if (this.tableEditor.lottable03 !== undefined && this.tableEditor.lottable03 !== null) {
          ColumnValue = this.tableEditor.lottable03;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable04') {
        if (this.lottable04 !== undefined && this.lottable04 !== null) {
          ColumnValue = this.lottable04;
        } else if (this.tableEditor.lottable04 !== undefined && this.tableEditor.lottable04 !== null) {
          ColumnValue = this.tableEditor.lottable04;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable05') {
        if (this.lottable05 !== undefined && this.lottable05 !== null) {
          ColumnValue = this.lottable05;
        } else if (this.tableEditor.lottable05 !== undefined && this.tableEditor.lottable05 !== null) {
          ColumnValue = this.tableEditor.lottable05;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable06') {
        if (this.lottable06 !== undefined && this.lottable06 !== null) {
          ColumnValue = this.lottable06;
        } else if (this.tableEditor.lottable06 !== undefined && this.tableEditor.lottable06 !== null) {
          ColumnValue = this.tableEditor.lottable06;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable07') {
        if (this.lottable07 !== undefined && this.lottable07 !== null) {
          ColumnValue = this.lottable07;
        } else if (this.tableEditor.lottable07 !== undefined && this.tableEditor.lottable07 !== null) {
          ColumnValue = this.tableEditor.lottable07;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable08') {
        if (this.lottable08 !== undefined && this.lottable08 !== null) {
          ColumnValue = this.lottable08;
        } else if (this.tableEditor.lottable08 !== undefined && this.tableEditor.lottable08 !== null) {
          ColumnValue = this.tableEditor.lottable08;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable09') {
        if (this.lottable09 !== undefined && this.lottable09 !== null) {
          ColumnValue = this.lottable09;
        } else if (this.tableEditor.lottable09 !== undefined && this.tableEditor.lottable09 !== null) {
          ColumnValue = this.tableEditor.lottable09;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable10') {
        if (this.lottable10 !== undefined && this.lottable10 !== null) {
          ColumnValue = this.lottable10;
        } else if (this.tableEditor.lottable10 !== undefined && this.tableEditor.lottable10 !== null) {
          ColumnValue = this.tableEditor.lottable10;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable11') {
        if (this.lottable11 !== undefined && this.lottable11 !== null) {
          ColumnValue = this.lottable11;
        } else if (this.tableEditor.lottable11 !== undefined && this.tableEditor.lottable11 !== null) {
          ColumnValue = this.tableEditor.lottable11;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable12') {
        if (this.lottable12 !== undefined && this.lottable12 !== null) {
          ColumnValue = this.lottable12;
        } else if (this.tableEditor.lottable12 !== undefined && this.tableEditor.lottable12 !== null) {
          ColumnValue = this.tableEditor.lottable12;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable13') {
        if (this.lottable13 !== undefined && this.lottable13 !== null) {
          ColumnValue = this.lottable13;
        } else if (this.tableEditor.lottable13 !== undefined && this.tableEditor.lottable13 !== null) {
          ColumnValue = this.tableEditor.lottable13;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable14') {
        if (this.lottable14 !== undefined && this.lottable14 !== null) {
          ColumnValue = this.lottable14;
        } else if (this.tableEditor.lottable14 !== undefined && this.tableEditor.lottable14 !== null) {
          ColumnValue = this.tableEditor.lottable14;
        } else {
          ColumnValue = '';
        }
      } else if (colName === 'lottable15') {
        if (this.lottable15 !== undefined && this.lottable15 !== null) {
          ColumnValue = this.lottable15;
        } else if (this.tableEditor.lottable15 !== undefined && this.tableEditor.lottable15 !== null) {
          ColumnValue = this.tableEditor.lottable15;
        } else {
          ColumnValue = '';
        }
      } else {
        if (currentRow.cells[colName] && currentRow.cells[colName].cVal) {
          ColumnValue = currentRow.cells[colName].cVal;
        }
      }

    }
    return ColumnValue;
  }

  /**
   * construct criteria for rLoc
   */
  public createClauseForLoc(currentRow: any, property: any, isNewInstance?: boolean, isClearSearchInstance?: boolean) {
    const locClauseArray: any[] = [];
    const facilityColumnValue = this.getPrimaryColumnValue('facility', isNewInstance, currentRow);
    if (facilityColumnValue) {
      if (property === 'loc' && this.facilityList.length > 0 && this.facilityList.indexOf(facilityColumnValue) !== -1) {
        this.facilityList.forEach((facility) => {
          const defaultClause1 = new Clause();
          defaultClause1.column = COMMON_FIELDS.FACILITY;
          defaultClause1.operation = SEARCH_OPERATORS.EQUAL;
          defaultClause1.value = facility;
          defaultClause1.logicalOperation = locClauseArray.length > 0 ? SEARCH_OPERATORS.OR : '';
          locClauseArray.push(defaultClause1);
        });
      }
      else {
        const defaultClause1 = new Clause();
        defaultClause1.column = COMMON_FIELDS.FACILITY;
        defaultClause1.operation = SEARCH_OPERATORS.EQUAL;
        defaultClause1.value = facilityColumnValue;
        defaultClause1.logicalOperation = locClauseArray.length > 0 ? SEARCH_OPERATORS.AND : '';
        locClauseArray.push(defaultClause1);
      }

    }
    const lotColumnValue = this.getPrimaryColumnValue('lot', isNewInstance, currentRow);
    if (lotColumnValue) {
      const defaultClause2 = new Clause();
      defaultClause2.column = 'lot';
      defaultClause2.value = lotColumnValue;
      defaultClause2.operation = '=';
      defaultClause2.logicalOperation = locClauseArray.length > 0 ? 'AND' : '';
      locClauseArray.push(defaultClause2);
    }
    if (!isClearSearchInstance) {
      const locColumnValue = this.getPrimaryColumnValue('loc', isNewInstance, currentRow);
      if (locColumnValue) {
        const defaultClause3 = new Clause();
        defaultClause3.column = 'loc';
        defaultClause3.value = locColumnValue;
        defaultClause3.operation = '=';
        defaultClause3.logicalOperation = 'AND';
        locClauseArray.push(defaultClause3);
      }
    }
    return locClauseArray;
  }

  /**
   * createClauseForId
   */
  public createClauseForId(currentRow: any, property: any, isNewInstance?: boolean, isClearSearchInstance?: boolean) {
    const idClauseArray: any[] = [];
    const lotColumnValue = this.getPrimaryColumnValue('lot', isNewInstance, currentRow);
    if (lotColumnValue) {
      const defaultClause1 = new Clause();
      defaultClause1.column = 'lot';
      defaultClause1.value = lotColumnValue;
      defaultClause1.operation = '=';
      defaultClause1.logicalOperation = idClauseArray.length > 0 ? 'AND' : '';
      idClauseArray.push(defaultClause1);
    }
    const locColumnValue = this.getPrimaryColumnValue('loc', isNewInstance, currentRow);
    if (locColumnValue) {
      const defaultClause2 = new Clause();
      defaultClause2.column = 'loc';
      defaultClause2.value = locColumnValue;
      defaultClause2.operation = '=';
      defaultClause2.logicalOperation = idClauseArray.length > 0 ? 'AND' : '';
      idClauseArray.push(defaultClause2);
    }
    const facilityColumnValue = this.getPrimaryColumnValue('facility', isNewInstance, currentRow);
    if (facilityColumnValue) {
      if (property === 'id' && this.facilityList.length > 0 && this.facilityList.indexOf(facilityColumnValue) !== -1) {
        this.facilityList.forEach((facility) => {
          const defaultClause1 = new Clause();
          defaultClause1.column = COMMON_FIELDS.FACILITY;
          defaultClause1.operation = SEARCH_OPERATORS.EQUAL;
          defaultClause1.value = facility;
          defaultClause1.logicalOperation = idClauseArray.length > 0 ? SEARCH_OPERATORS.OR : '';
          idClauseArray.push(defaultClause1);
        });
      } else {
        const defaultClause1 = new Clause();
        defaultClause1.column = COMMON_FIELDS.FACILITY;
        defaultClause1.operation = SEARCH_OPERATORS.EQUAL;
        defaultClause1.value = facilityColumnValue;
        defaultClause1.logicalOperation = idClauseArray.length > 0 ? SEARCH_OPERATORS.AND : '';
        idClauseArray.push(defaultClause1);
      }

    }
    if (!isClearSearchInstance) {
      const idColumnValue = this.getPrimaryColumnValue('id', isNewInstance, currentRow);
      if (idColumnValue) {
        const defaultClause4 = new Clause();
        defaultClause4.column = 'id';
        defaultClause4.value = idColumnValue;
        defaultClause4.operation = '=';
        defaultClause4.logicalOperation = idClauseArray.length > 0 ? 'AND' : '';
        idClauseArray.push(defaultClause4);
      }
    }

    return idClauseArray;
  }

  // create search params for the corresponding table ID.
  protected createLookupParamsForColumn(tableId: any, primaryId: any) {
    const lookupParams = new SearchParams();
    lookupParams.isFullFetch = true;
    lookupParams.columnCount = 10;
    lookupParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.editable = true;
    tableConfig.showIdAsAHyperLink = false;
    tableConfig.supportFiltering = true;
    lookupParams.dataTableConfig = tableConfig;
    lookupParams.tableId = tableId;
    lookupParams.idProperty = primaryId;

    return lookupParams;
  }

  // create an instance of condition
  protected createSearchCondition(id: any) {
    const searchCondition = new Condition();
    searchCondition.id = id;
    searchCondition.displayMode = 'VIEW';
    return searchCondition;
  }

  private getCellValue(cells: any, field: string) {
    const cell = cells[field];
    return cell ? cell.cVal : '';
  }

  /**
   * when user wants to navigate to the next step it is called
   * here the logic for switch the search criteria
   * and storing the user selected value is handled
   */
  public onStepChangeForward() {
    const selectedRow: any[] = this.searchService.getSelectedRows();
    if (this.searchService.getPagedData().pageRows.length === 0) {
      this.alertService.clearAll()
        .error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (selectedRow.length === 0) {
      this.alertService.clearAll()
        .error(this.resourceService.get('msg_sel_detail'));
      return;
    } else if (selectedRow.length > 1) {
      this.alertService.clearAll()
        .error(this.resourceService.get('msg_multiple_entries'));
      return;
    } else {
      this.isLoading = true;
      this.showTable = false;
      if (this.property === 'orderLineNo') {
        this.itemsToPopulate.orderLineNo = selectedRow[0].cells['orderLineNumber'].cVal;
        this.itemsToPopulate.storerKey = selectedRow[0].cells['storerKey'].cVal;
        this.itemsToPopulate.commodity = selectedRow[0].cells['sku'].cVal;
        //start: [LFWM-4131] fetch channelID from orderlinetd and store in pickdetail channel id
        this.itemsToPopulate.channel = selectedRow[0].cells['channel'].cVal;
        //end: [LFWM-4131]
        //[LFWM-3573] to pass the facility to get the data
        this.itemsToPopulate.facility = selectedRow[0].cells['facility'].cVal ? selectedRow[0].cells['facility'].cVal : this.selectedFacility;
        this.itemsToPopulate.packKey = selectedRow[0].cells['packKey'].cVal;
        this.itemsToPopulate.lottable01 = selectedRow[0].cells['lottable01'].cVal;
        this.itemsToPopulate.lottable02 = selectedRow[0].cells['lottable02'].cVal;
        this.itemsToPopulate.lottable03 = selectedRow[0].cells['lottable03'].cVal;
        this.itemsToPopulate.lottable04 = selectedRow[0].cells['lottable04'].cVal;
        this.itemsToPopulate.lottable05 = selectedRow[0].cells['lottable05'].cVal;
        this.itemsToPopulate.lottable06 = selectedRow[0].cells['lottable06'].cVal;
        this.itemsToPopulate.lottable07 = selectedRow[0].cells['lottable07'].cVal;
        this.itemsToPopulate.lottable08 = selectedRow[0].cells['lottable08'].cVal;
        this.itemsToPopulate.lottable09 = selectedRow[0].cells['lottable09'].cVal;
        this.itemsToPopulate.lottable10 = selectedRow[0].cells['lottable10'].cVal;
        this.itemsToPopulate.lottable11 = selectedRow[0].cells['lottable11'].cVal;
        this.itemsToPopulate.lottable12 = selectedRow[0].cells['lottable12'].cVal;
        this.itemsToPopulate.lottable13 = selectedRow[0].cells['lottable13'].cVal;
        this.itemsToPopulate.lottable14 = selectedRow[0].cells['lottable14'].cVal;
        this.itemsToPopulate.lottable15 = selectedRow[0].cells['lottable15'].cVal;
        this.itemsToPopulate.description = selectedRow[0].cells['descr'].cVal;
        this.itemsToPopulate.openQty = selectedRow[0].cells['openQty'].cVal;
        this.itemsToPopulate.orderKey = selectedRow[0].cells['orderKey'].cVal;
        this.itemsToPopulate.qtyAllocated = selectedRow[0].cells['qtyAllocated'].cVal;
        this.itemsToPopulate.unallocatedOpen = selectedRow[0].cells['unallocatedOpen'].cVal;
        //[LFWM-3573] to pass the facility to get the data
        this.facility = selectedRow[0].cells['facility'].cVal ? selectedRow[0].cells['facility'].cVal : this.selectedFacility;
        this.storerKey = selectedRow[0].cells['storerKey'].cVal;
        this.sku = selectedRow[0].cells['sku'].cVal;
        this.lottable01 = selectedRow[0].cells['lottable01'].cVal;
        this.lottable02 = selectedRow[0].cells['lottable02'].cVal;
        this.lottable03 = selectedRow[0].cells['lottable03'].cVal;
        this.lottable04 = selectedRow[0].cells['lottable04'].cVal;
        this.lottable05 = selectedRow[0].cells['lottable05'].cVal;
        this.lottable06 = selectedRow[0].cells['lottable06'].cVal;
        this.lottable07 = selectedRow[0].cells['lottable07'].cVal;
        this.lottable08 = selectedRow[0].cells['lottable08'].cVal;
        this.lottable09 = selectedRow[0].cells['lottable09'].cVal;
        this.lottable10 = selectedRow[0].cells['lottable10'].cVal;
        this.lottable11 = selectedRow[0].cells['lottable11'].cVal;
        this.lottable12 = selectedRow[0].cells['lottable12'].cVal;
        this.lottable13 = selectedRow[0].cells['lottable13'].cVal;
        this.lottable14 = selectedRow[0].cells['lottable14'].cVal;
        this.lottable15 = selectedRow[0].cells['lottable15'].cVal;
      } else if (this.property === 'lot') {
        this.itemsToPopulate.lot = selectedRow[0].cells['lot'].cVal;
        this.itemsToPopulate.qtyAvailable = selectedRow[0].cells['qtyAvailable'].cVal;
        this.itemsToPopulate.loc = this.getCellValue(selectedRow[0].cells, META_DATA.LOC);
        this.itemsToPopulate.id = this.getCellValue(selectedRow[0].cells, META_DATA.ID);
        this.itemsToPopulate.lottable01 = selectedRow[0].cells['lottable01'].cVal;
        this.itemsToPopulate.lottable02 = selectedRow[0].cells['lottable02'].cVal;
        this.itemsToPopulate.lottable03 = selectedRow[0].cells['lottable03'].cVal;
        this.itemsToPopulate.lottable04 = selectedRow[0].cells['lottable04'].cVal;
        this.itemsToPopulate.lottable05 = selectedRow[0].cells['lottable05'].cVal;
        this.itemsToPopulate.lottable06 = selectedRow[0].cells['lottable06'].cVal;
        this.itemsToPopulate.lottable07 = selectedRow[0].cells['lottable07'].cVal;
        this.itemsToPopulate.lottable08 = selectedRow[0].cells['lottable08'].cVal;
        this.itemsToPopulate.lottable09 = selectedRow[0].cells['lottable09'].cVal;
        this.itemsToPopulate.lottable10 = selectedRow[0].cells['lottable10'].cVal;
        this.itemsToPopulate.lottable11 = selectedRow[0].cells['lottable11'].cVal;
        this.itemsToPopulate.lottable12 = selectedRow[0].cells['lottable12'].cVal;
        this.itemsToPopulate.lottable13 = selectedRow[0].cells['lottable13'].cVal;
        this.itemsToPopulate.lottable14 = selectedRow[0].cells['lottable14'].cVal;
        this.itemsToPopulate.lottable15 = selectedRow[0].cells['lottable15'].cVal;
      } else if (this.property === 'loc') {
        this.itemsToPopulate.loc = selectedRow[0].cells['loc'].cVal;
        this.itemsToPopulate.qtyAvailable = selectedRow[0].cells['qtyAvailable'].cVal;
      }
      this.selectedPropertyValue[this.property] = this.itemsToPopulate[this.property];
      this.selectedStep = this.propertyArray.indexOf(this.property) + 1;
      this.property = this.propertyArray[this.selectedStep];
      this.selectedStepName = this.resourceService.get(this.stepNameMap[this.property]);
      this.searchService = this.searchServices[this.selectedStep];
      this.searchParams = this.searchService.searchParams;
      this.searchStatus = this.searchService.searchStatus;
      this.selectedPropertyValue[this.property] = '';
      setTimeout(() => {
        this.searchService.fetchMetadata()
          .subscribe(() => {
            this.searchService.setSearchCriteria(this.createDefaultSearchCriteria(selectedRow[0], this.property));
            /* here perform search is replace with fetchsearch results since some operations needs to be on its subscribe part
             * here we are setting slected texbox value
             * enablbling checkbox for selected value - jira-[LFWM-1764]
             */
            this.searchService.fetchSearchResults()
              .subscribe((data: any) => {
                this.searchStatus.hasResults = true;
                this.searchStatus.recordCount = this.searchService.pagedData.pageDefinition.recordCount;
                const event = new SearchEvent(NEW_SEARCH_EVENT);
                event.isSearchSuccess = true;
                this.searchService.publishEvent(event);
                if (this.isNewInstanceCreated) {
                  const checkboxChecked: boolean = this.checkPreviousPropValue();
                  if (checkboxChecked && this.searchService.getPagedData().pageRows.length === 1) {
                      this.selectedPropertyValue[this.property] = this.searchService.getPagedData().pageRows[0].cells[this.property].cVal;
                    this.searchService.getPagedData().pageRows[0].isSelected = true;
                  }
                  this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
                }
              }, (error) => {
                this.alertService.clearAll().error(error);
              });
            this.isLoading = false;
            this.showTable = true;
          });
      }, 10);
    }
  }

  /**
   * checkPreviousPropValue same or not to enable checkbox
   */
  public checkPreviousPropValue() {
    let checkboxChecked: boolean = true;
    const steplength = this.propertyArray.indexOf(this.property);
    for (let i = 0; i < steplength; i++) {
      const property = this.propertyArray[i];
      if (this.selectedPropertyValue[property] && !(this.selectedPropertyValue[property] === this.currentRow.cells[property].cVal)) {
        checkboxChecked = false;
      }
    }
    return checkboxChecked;
  }

  /**
   * when user wants to navigate to the previous step it is called
   * here the logic for switch the search criteria
   * and clearing the user selected value is handled
   */
  public onStepChangeBackward() {
    this.isLoading = true;
    this.showTable = false;
    this.itemsToPopulate[this.property] = '';
    this.selectedStep = this.propertyArray.indexOf(this.property) - 1;
    this.property = this.propertyArray[this.selectedStep];
    this.selectedStepName = this.resourceService.get(this.stepNameMap[this.property]);
    this.searchService = this.searchServices[this.selectedStep];
    this.searchParams = this.searchService.searchParams;
    this.searchStatus = this.searchService.searchStatus;
    this.selectedPropertyValue[this.property] = this.selectedPropertyValue[this.property] ?
      this.selectedPropertyValue[this.property] : this.currentRow.cells[this.property].cVal;
    // here the search criteria will undefined if the user didnt select the previous step values
    // eg:- user didnt select value for orderlineNO and lot but clicks on loc and tends to navigate back
    // we need to load all the rows related to primary data
    if (this.searchService.getSearchCriteria()) {
      setTimeout(() => {
        this.searchService.fetchMetadata()
          .subscribe(() => {
            this.isLoading = false;
            this.showTable = true;
          });
      }, 10);
    } else {
      setTimeout(() => {
        this.searchService.fetchMetadata()
          .subscribe(() => {
            this.searchService.setSearchCriteria(this.createDefaultSearchCriteria(this.currentRow, this.property, true));
            this.searchService.fetchSearchResults()
              .subscribe((data: any) => {
                this.searchStatus.hasResults = true;
                this.searchStatus.recordCount = this.searchService.pagedData.pageDefinition.recordCount;
                const event = new SearchEvent(NEW_SEARCH_EVENT);
                event.isSearchSuccess = true;
                this.searchService.publishEvent(event);
                if (this.searchService.getPagedData().pageRows.length === 1) {
                  this.searchService.getPagedData().pageRows[0].isSelected = true;
                }
                this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
              });
            this.isLoading = false;
            this.showTable = true;
          });
      }, 10);
    }
  }

  /**
   * user selected value from the steps is passed to the parent component for auto population
   */
  public populateMultiColumn() {
    const selectedRow: any[] = this.searchService.getSelectedRows();
    if (selectedRow.length === 0) {
      this.alertService.clearAll()
        .error(this.resourceService.get('msg_sel_detail'));
      return;
    } else if (selectedRow.length > 1) {
      this.alertService.clearAll()
        .error(this.resourceService.get('msg_multiple_entries'));
      return;
    } else {
      if (this.property === 'orderLineNo') {
        this.itemsToPopulate.orderLineNo = selectedRow[0].cells['orderLineNumber'].cVal;
        this.itemsToPopulate.storerKey = selectedRow[0].cells['storerKey'].cVal;
        this.itemsToPopulate.commodity = selectedRow[0].cells['sku'].cVal;
        this.itemsToPopulate.channel = selectedRow[0].cells['channel'].cVal;
        //[LFWM-3573] to pass the facility to get the data
        this.itemsToPopulate.facility = selectedRow[0].cells['facility'].cVal ? selectedRow[0].cells['facility'].cVal : this.selectedFacility;        
        this.itemsToPopulate.packKey = selectedRow[0].cells['packKey'].cVal;
        this.itemsToPopulate.lottable01 = selectedRow[0].cells['lottable01'].cVal;
        this.itemsToPopulate.lottable02 = selectedRow[0].cells['lottable02'].cVal;
        this.itemsToPopulate.lottable03 = selectedRow[0].cells['lottable03'].cVal;
        this.itemsToPopulate.lottable04 = selectedRow[0].cells['lottable04'].cVal;
        this.itemsToPopulate.lottable05 = selectedRow[0].cells['lottable05'].cVal;
        this.itemsToPopulate.lottable06 = selectedRow[0].cells['lottable06'].cVal;
        this.itemsToPopulate.lottable07 = selectedRow[0].cells['lottable07'].cVal;
        this.itemsToPopulate.lottable08 = selectedRow[0].cells['lottable08'].cVal;
        this.itemsToPopulate.lottable09 = selectedRow[0].cells['lottable09'].cVal;
        this.itemsToPopulate.lottable10 = selectedRow[0].cells['lottable10'].cVal;
        this.itemsToPopulate.lottable11 = selectedRow[0].cells['lottable11'].cVal;
        this.itemsToPopulate.lottable12 = selectedRow[0].cells['lottable12'].cVal;
        this.itemsToPopulate.lottable13 = selectedRow[0].cells['lottable13'].cVal;
        this.itemsToPopulate.lottable14 = selectedRow[0].cells['lottable14'].cVal;
        this.itemsToPopulate.lottable15 = selectedRow[0].cells['lottable15'].cVal;
        this.itemsToPopulate.description = selectedRow[0].cells['descr'].cVal;
        this.itemsToPopulate.openQty = selectedRow[0].cells['openQty'].cVal;
        this.itemsToPopulate.orderKey = selectedRow[0].cells['orderKey'].cVal;
        this.itemsToPopulate.qtyAllocated = selectedRow[0].cells['qtyAllocated'].cVal;
        this.itemsToPopulate.unallocatedOpen = selectedRow[0].cells['unallocatedOpen'].cVal;
      } else if (this.property === 'lot') {
        this.itemsToPopulate.lot = selectedRow[0].cells['lot'].cVal;
        this.itemsToPopulate.qtyAvailable = selectedRow[0].cells['qtyAvailable'].cVal;
        this.itemsToPopulate.loc = this.getCellValue(selectedRow[0].cells, META_DATA.LOC);
        this.itemsToPopulate.id = this.getCellValue(selectedRow[0].cells, META_DATA.ID);
        this.itemsToPopulate.lottable01 = selectedRow[0].cells['lottable01'].cVal;
        this.itemsToPopulate.lottable02 = selectedRow[0].cells['lottable02'].cVal;
        this.itemsToPopulate.lottable03 = selectedRow[0].cells['lottable03'].cVal;
        this.itemsToPopulate.lottable04 = selectedRow[0].cells['lottable04'].cVal;
        this.itemsToPopulate.lottable05 = selectedRow[0].cells['lottable05'].cVal;
        this.itemsToPopulate.lottable06 = selectedRow[0].cells['lottable06'].cVal;
        this.itemsToPopulate.lottable07 = selectedRow[0].cells['lottable07'].cVal;
        this.itemsToPopulate.lottable08 = selectedRow[0].cells['lottable08'].cVal;
        this.itemsToPopulate.lottable09 = selectedRow[0].cells['lottable09'].cVal;
        this.itemsToPopulate.lottable10 = selectedRow[0].cells['lottable10'].cVal;
        this.itemsToPopulate.lottable11 = selectedRow[0].cells['lottable11'].cVal;
        this.itemsToPopulate.lottable12 = selectedRow[0].cells['lottable12'].cVal;
        this.itemsToPopulate.lottable13 = selectedRow[0].cells['lottable13'].cVal;
        this.itemsToPopulate.lottable14 = selectedRow[0].cells['lottable14'].cVal;
        this.itemsToPopulate.lottable15 = selectedRow[0].cells['lottable15'].cVal;
      } else if (this.property === 'loc') {
        this.itemsToPopulate.loc = selectedRow[0].cells['loc'].cVal;
        this.itemsToPopulate.qtyAvailable = selectedRow[0].cells['qtyAvailable'].cVal;
      } else if (this.property === 'id') {
        this.itemsToPopulate.id = selectedRow[0].cells['id'].cVal;
      }        
      const populateEvent = { 'type': 'populate', 'selectedItems': this.itemsToPopulate };
      this.notifyEvent(populateEvent);
    }
  }

  /**
   * when the user selects the clear icon the search criteria has to be cleared
   * here the clearing of search criteria is handled
   */
  public clearSearchCriteria() {
    this.isLoading = true;
    this.showTable = false;
    this.selectedPropertyValue[this.property] = '';
    setTimeout(() => {
      this.searchService.fetchMetadata()
        .subscribe(() => {
          this.searchService.setSearchCriteria(this.createDefaultSearchCriteria(this.currentRow, this.property, false, true));
          this.searchService.fetchSearchResults()
            .subscribe((data: any) => {
              this.searchStatus.hasResults = true;
              this.searchStatus.recordCount = this.searchService.pagedData.pageDefinition.recordCount;
              const event = new SearchEvent(NEW_SEARCH_EVENT);
              event.isSearchSuccess = true;
              this.searchService.publishEvent(event);
              this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
            });
          this.isLoading = false;
          this.showTable = true;
        });
    }, 10);
  }

  /*
   * events used to pass data from child to parent
   */
  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/multi-column-popup/multi-column-popup.component.ts